"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebP = exports.applyFilters = void 0;
function applyFilters(filters) {
    if (filters.length === 0) {
        return '';
    }
    return `/filters:${filters.join(':')}`;
}
exports.applyFilters = applyFilters;
function isWebP(url) {
    const isConverted = url.includes('filters:format(webp)');
    const isOriginal = /\.webp$/.test(url);
    return isConverted || isOriginal;
}
exports.isWebP = isWebP;
